var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5997_133519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5997_133519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58301 21.3333H22.9163C24.383 21.3333 25.6386 20.8111 26.683 19.7667C27.7275 18.7222 28.2497 17.4667 28.2497 16C28.2497 14.5333 27.7275 13.2778 26.683 12.2333C25.6386 11.1889 24.383 10.6667 22.9163 10.6667H9.58301C8.11634 10.6667 6.86079 11.1889 5.81634 12.2333C4.7719 13.2778 4.24967 14.5333 4.24967 16C4.24967 17.4667 4.7719 18.7222 5.81634 19.7667C6.86079 20.8111 8.11634 21.3333 9.58301 21.3333ZM13.583 8H18.9163V6.66667H13.583V8ZM12.2497 24V26.6667C12.2497 27.0444 12.1219 27.3611 11.8663 27.6167C11.6108 27.8722 11.2941 28 10.9163 28C10.5386 28 10.2219 27.8722 9.96634 27.6167C9.71079 27.3611 9.58301 27.0444 9.58301 26.6667V24C7.36079 24 5.4719 23.2222 3.91634 21.6667C2.36079 20.1111 1.58301 18.2222 1.58301 16C1.58301 13.7778 2.36079 11.8889 3.91634 10.3333C5.4719 8.77778 7.36079 8 9.58301 8H10.9163V6.66667C10.9163 5.93333 11.1775 5.30556 11.6997 4.78333C12.2219 4.26111 12.8497 4 13.583 4H18.9163C19.6497 4 20.2775 4.26111 20.7997 4.78333C21.3219 5.30556 21.583 5.93333 21.583 6.66667V8H22.9163C25.1386 8 27.0275 8.77778 28.583 10.3333C30.1386 11.8889 30.9163 13.7778 30.9163 16C30.9163 18.2222 30.1386 20.1111 28.583 21.6667C27.0275 23.2222 25.1386 24 22.9163 24V26.6667C22.9163 27.0444 22.7886 27.3611 22.533 27.6167C22.2775 27.8722 21.9608 28 21.583 28C21.2052 28 20.8886 27.8722 20.633 27.6167C20.3775 27.3611 20.2497 27.0444 20.2497 26.6667V24H12.2497Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasolio);
export default __webpack_public_path__ + "static/media/gasolio.8d2f8225e59a63b774dd555ea852e952.svg";
export { ForwardRef as ReactComponent };